function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 172,
    viewBox: "0 0 167 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M83.6058 171.623C37.7696 171.623 0.468262 133.128 0.468262 85.8225C0.468262 38.5166 37.7579 0.0214844 83.6058 0.0214844C129.454 0.0214844 166.743 38.5166 166.743 85.8225C166.743 133.128 129.454 171.623 83.6058 171.623ZM83.6058 3.66226C39.7094 3.66226 3.99503 40.5191 3.99503 85.8225C3.99503 131.126 39.7094 167.983 83.6058 167.983C127.502 167.983 163.217 131.126 163.217 85.8225C163.217 40.5191 127.502 3.66226 83.6058 3.66226Z",
    fill: "yellow",
    style: {
      filter: "drop-shadow(2px 2px 9px yellow)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M83.6058 150.179C73.5427 150.179 65.349 141.733 65.349 131.332V104.657H39.5096C29.4466 104.657 21.2527 96.2108 21.2527 85.8103C21.2527 75.4099 29.4466 66.9633 39.5096 66.9633H65.349V40.2885C65.349 29.9001 73.5427 21.4414 83.6058 21.4414C93.6688 21.4414 101.863 29.9001 101.863 40.2885V66.9633H127.702C137.765 66.9633 145.959 75.4099 145.959 85.8103C145.959 96.2108 137.765 104.657 127.702 104.657H101.863V131.332C101.863 141.721 93.6688 150.179 83.6058 150.179ZM39.5096 70.6162C31.3863 70.6162 24.7794 77.4366 24.7794 85.8225C24.7794 94.2084 31.3863 101.029 39.5096 101.029H67.1124C68.0881 101.029 68.8758 101.842 68.8758 102.849V131.344C68.8758 139.73 75.4825 146.551 83.6058 146.551C91.7291 146.551 98.3359 139.73 98.3359 131.344V102.849C98.3359 101.842 99.1236 101.029 100.099 101.029H127.702C135.825 101.029 142.432 94.2084 142.432 85.8225C142.432 77.4366 135.825 70.6162 127.702 70.6162H100.099C99.1236 70.6162 98.3359 69.8031 98.3359 68.7958V40.3006C98.3359 31.9147 91.7291 25.0943 83.6058 25.0943C75.4825 25.0943 68.8758 31.9147 68.8758 40.3006V68.7958C68.8758 69.8031 68.0881 70.6162 67.1124 70.6162H39.5096Z",
    fill: "#32d8d3",
    style: {
      filter: "drop-shadow(2px 2px 9px #32d8d3)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c7044fa3bb84fece616cdf46c9fee692.svg";
export { ForwardRef as ReactComponent };